import { z } from "zod";

/**
 * 新密码规则:不许 123456(老的全网初始值,存量账号仍可能是它),也不许与本次登录用的初始密码相同
 * (修复波 0926 K:初始密码改为随机后,「改成跟原来一样」同样等于没改;后端 /me/password 同口径再拦一道)。
 */
export function makeForcePasswordSchema(oldPassword: string) {
  return z
    .object({
      newPassword: z
        .string()
        .min(8, "至少 8 位")
        .refine((v) => v !== "123456", "不能继续用初始密码")
        .refine((v) => v !== oldPassword, "不能与初始密码相同"),
      confirm: z.string(),
    })
    .refine((v) => v.newPassword === v.confirm, {
      path: ["confirm"],
      message: "两次输入不一致",
    });
}

/**
 * 刷新后恢复的强制改密(0930):登录时输入的初始密码只在 LoginPage 内存里,刷新即丢 —— 此时让用户自己再输一遍当前密码。
 * 规则同上(不许 123456、不许与当前密码相同),外加当前密码必填。
 */
export function makeForcePasswordSchemaAskOld() {
  return z
    .object({
      oldPassword: z.string().min(1, "请输入当前密码"),
      newPassword: z
        .string()
        .min(8, "至少 8 位")
        .refine((v) => v !== "123456", "不能继续用初始密码"),
      confirm: z.string(),
    })
    .refine((v) => v.newPassword !== v.oldPassword, {
      path: ["newPassword"],
      message: "不能与初始密码相同",
    })
    .refine((v) => v.newPassword === v.confirm, {
      path: ["confirm"],
      message: "两次输入不一致",
    });
}
